export enum KeyCode {
  ENTER = 'Enter'
}
